import { Layout, formatMoney, spendSourceColor } from './_barrel.js';


        function SpendChart({ data, currency }) {
            const buckets = data.buckets;
            const sources = data.totals_by_source.map(s => s.source);
            if (!buckets.length || !sources.length) return null;

            // Layout
            const W = 800;
            const H = 240;
            const padL = 60;
            const padR = 20;
            const padT = 12;
            const padB = 36;
            const plotW = W - padL - padR;
            const plotH = H - padT - padB;

            // Max bucket total for y-scale
            const maxTotal = Math.max(...buckets.map(b => b.total)) || 1;

            // Bar geometry
            const n = buckets.length;
            const slot = plotW / n;
            const barW = Math.max(2, slot * 0.7);
            const gap = (slot - barW) / 2;

            // Y-axis ticks (4 of them)
            const ticks = [0, 0.25, 0.5, 0.75, 1].map(f => ({
                y: padT + plotH * (1 - f),
                label: formatMoney(maxTotal * f, currency),
            }));

            // X-axis labels — show ~6 evenly spaced labels
            const labelEvery = Math.max(1, Math.ceil(n / 6));
            const fmt = (iso) => {
                const d = new Date(iso);
                if (data.granularity === 'hour') return d.toISOString().slice(11, 16);
                return d.toISOString().slice(5, 10);
            };

            return (
                <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{display:'block'}}>
                    {/* Gridlines + y-axis labels */}
                    {ticks.map((t, i) => (
                        <g key={i}>
                            <line x1={padL} y1={t.y} x2={W - padR} y2={t.y} stroke="#232d42" strokeDasharray="2,3" />
                            <text x={padL - 6} y={t.y + 4} fontSize="10" fill="#79839a" textAnchor="end" fontFamily="monospace">{t.label}</text>
                        </g>
                    ))}

                    {/* Bars — each bucket stacked by source */}
                    {buckets.map((b, i) => {
                        let yCursor = padT + plotH;
                        const x = padL + i * slot + gap;
                        return (
                            <g key={i}>
                                {sources.map(src => {
                                    const v = b.sources[src] || 0;
                                    if (v <= 0) return null;
                                    const h = (v / maxTotal) * plotH;
                                    yCursor -= h;
                                    return (
                                        <rect key={src} x={x} y={yCursor} width={barW} height={h} fill={spendSourceColor(src)}>
                                            <title>{src}: {formatMoney(v, currency, 6)} on {fmt(b.bucket_start)}</title>
                                        </rect>
                                    );
                                })}
                            </g>
                        );
                    })}

                    {/* X-axis labels */}
                    {buckets.map((b, i) => {
                        if (i % labelEvery !== 0) return null;
                        const x = padL + i * slot + slot / 2;
                        return (
                            <text key={i} x={x} y={H - padB + 16} fontSize="10" fill="#79839a" textAnchor="middle" fontFamily="monospace">
                                {fmt(b.bucket_start)}
                            </text>
                        );
                    })}

                    {/* X-axis baseline */}
                    <line x1={padL} y1={padT + plotH} x2={W - padR} y2={padT + plotH} stroke="#4a5468" />
                </svg>
            );
        }

export { SpendChart };
